module.exports = __webpack_public_path__ + "static/parade-2020-house01-964494bca4ea40b1d6a934329a1f10eb.jpg";